import {
  get, post, update, hapus, upload, download
} from './helpers'

// API GENERAL
export function getPerekomendasi($data) {
  return get(`peserta/perekomendasi`, $data)
}

export function getJadwal($data) {
  return get(`peserta/jadwal`, $data)
}

export function getStatus($data) {
  return get(`peserta/status`, $data)
}

export function getLembarKehidupan($data) {
  return get(`peserta/lembar-kehidupan`, $data)
}

export function updateLembarKehidupan($data, $step = 'all') {
  $data.step = $step;
  return post(`peserta/lembar-kehidupan`, $data)
}

export function postPengalamanKerja($data) {
  return post(`peserta/pengalaman-pekerjaan`, $data)
}

export function deletePengalamanKerja($uuid) {
  return hapus(`peserta/pengalaman-pekerjaan?uuid=${$uuid}`)
}

export function patchPeminatan($uuid, $jawaban) {
  return update(`peserta/peminatan?uuid=${$uuid}&jawaban=${$jawaban}`)
}

export function getBerkas($data) {
  return get(`peserta/persyaratan-berkas`, $data)
}
export function downloadBerkas(filename) {
  return download(`peserta/persyaratan-berkas/download?filename=${filename}`);
}
export function downloadPhoto($data) {
  return get(`peserta/foto`, $data);
}
export function uploadFileBerkas(file, metadata, onUploadProgress) {
  return upload(
    "peserta/persyaratan-berkas/upload",
    file,
    metadata,
    onUploadProgress
  );
}
export function uploadFoto(file, metadata, onUploadProgress) {
  return upload(
    "peserta/foto",
    file,
    metadata,
    onUploadProgress
  );
}
